import { useMemo } from 'react';
import Head from 'next/head';
import Script from 'next/script';
import { useUser } from '@clerk/nextjs';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';

import { Container } from '@ui/Container';

import SEOHead from '@components/SEOHead';
import Header from '@components/layout/Header';
import { Footer } from '@components/layout/Footer';

import LeftInfoCryptoSection from '@components/elements/pricing/LeftInfoCryptoSection';

import { Subscriptions } from '@components/PlansPage/Subscriptions';
import { Bundles } from '@components/PlansPage/Bundles';
import CryptoCard from '@components/elements/pricing/CryptoCard';
import { MessagesLastMonth } from '@components/PlansPage/MessagesLastMonth';
import { ReviewsCardSection } from '@components/ReviewsCardSection';
import { reviews } from '@data/reviews';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { DualAppBanner } from '@components/SweetWaifu/DualAppBanner';
import { MobileDetails } from '@components/HomePage/MobileDetails';

export default function Plans({ reviewsColLeft, reviewsColRight, locale }) {
  const router = useRouter();
  const { t: tt } = useTranslation('plans');

  const { isSignedIn, user, isLoaded } = useUser();

  /**
   * @type {string}
   */
  const userEmail = useMemo(() => {
    if (isLoaded && isSignedIn && user.emailAddresses.length > 0) {
      return user.emailAddresses[0].emailAddress;
    }

    return '';
  }, [isLoaded, isSignedIn, user]);

  const trackConversion = () => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-16495598205/XOXDCI3y5qYZEP2027k9',
        event_callback: () => console.log('success'),
      });
    } else {
      console.log('gtag not initialized');
    }
  };

  // Function to handle button click
  const handleButtonClick = () => {
    // trackConversion();

    // Open the link in a new tab
    // window.open('https://www.patreon.com/aigirlfriendwtf/membership', '_blank');
    window.open(
      'https://shoptextadventures.gumroad.com/l/aigirlfriend?wanted=true',
      '_blank',
    );
  };

  return (
    <>
      <SEOHead
        title="Get more messages for you AI girlfriends"
        description="Enjoy more messages from you favourite AI girls, jump into new exiting adventures by unlocking message plans"
        type="website"
        keywords="bypass character ai filter, bypass c ai filter with AI girlfriend, best character ai alternative ,unlock more messages, free ai girlfriend,, "
        url="https://www.aigirlfriend.wtf/plans"
        imageUrl="https://www.aigirlfriend.wtf/web-banner-min.jpg"
      />

      <Header />

      <Container
        as="main"
        className={clsx(
          'pt-[105px] pb-[40px] px-[30px]',
          'flex flex-col gap-[80px]',
        )}
      >
        <div className="mb-[60px]">
          <h1
            className={clsx(
              'mt-0 mb-[16px]',
              'text-center text-[32px] leading-tight text-wtf-white font-bold',
            )}
          >
            {tt('title')}
          </h1>
          <p
            className={clsx(
              'mt-0 mb-[48px] mx-auto',
              'max-w-screen-md',
              'text-center text-[20px] text-wtf-white/60',
            )}
          >
            {tt('description')}
          </p>
          <Subscriptions />
          <div
            className={clsx(
              'container-xs',
              'mt-8',
              'flex flex-col items-center',
              'xl:flex-row xl:justify-between xl:items-stretch',
              'pt-5',
              'pb-0',
            )}
          >
            {/*It takes 30 seconds to fulfill all your fantasies: /!*<button*!/*/}
            {/*  type="button"*/}
            {/*  className={clsx(*/}
            {/*    'flex flex-row justify-center items-center',*/}
            {/*    'py-[12px] px-[24px]',*/}
            {/*    'text-[20px] leading-none font-semibold text-wtf-white',*/}
            {/*    'bg-blue-600',*/}
            {/*    'plausible-event-name=Patron+Click+Conversion', //used to track custom goals for Plausible*/}
            {/*  )}*/}
            {/*  onClick={handleButtonClick}*/}
            {/*>*/}
            {/*  Get Subscription ⭐️*/}
            {/*</button>*/}
          </div>
          {/*<div*/}
          {/*  className={clsx(*/}
          {/*    'mt-[12px]',*/}
          {/*    'flex flex-col items-center',*/}
          {/*    'text-xs',*/}
          {/*    'font-bold',*/}
          {/*  )}*/}
          {/*>*/}
          {/*  *Please use the same email*/}
          {/*</div>*/}

          <DualAppBanner />
          <br />
          <MobileDetails />
        </div>

        {/*<div*/}
        {/*  className={clsx(*/}
        {/*    'container-sm',*/}
        {/*    'flex flex-col items-center',*/}
        {/*    'xl:flex-row xl:justify-between xl:items-stretch',*/}
        {/*    'gap-6',*/}
        {/*  )}*/}
        {/*>*/}
        {/*  <LeftInfoCryptoSection />*/}
        {/*  <CryptoCard checkout_link="/crypto-payment" />*/}
        {/*</div>*/}

        <MessagesLastMonth />

        {/*{user && user.id && (*/}
        {/*  <Bundles*/}
        {/*    className="container-sm"*/}
        {/*    userId={user.id}*/}
        {/*    userEmail={userEmail}*/}
        {/*  />*/}
        {/*)}*/}
        <ReviewsCardSection
          reviewsColRight={reviewsColRight}
          reviewsColLeft={reviewsColLeft}
        />
      </Container>

      <Footer />
    </>
  );
}

export async function getStaticProps({ locale }) {
  const reviewsColLeft = reviews.slice(0, Math.ceil(reviews.length / 2));
  const reviewsColRight = reviews.slice(Math.ceil(reviews.length / 2));
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'header',
        'plans',
        'reviews',
        'footer',
      ])),
      reviewsColLeft,
      reviewsColRight,
      locale,
    },
  };
}
